import axios from 'axios';
import { environment } from '../../environments/environment';

const axiosClient = axios.create({
  baseURL: environment.apiUrl,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosClient.interceptors.request.use((config: any) => {
  const token = sessionStorage.getItem('token');

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    window.location.href = '/auth/login';
    return config;
  }
  
  return config;
});

export default axiosClient;
